// SessionCostBadge.tsx — what the open conversation has cost so far, as a
// single quiet figure in the lifecycle banner with the breakdown in its
// tooltip.
//
// Deliberately renders nothing when the cost is unknown (nothing metered
// stored yet, or metering off): "$0.00" would claim the conversation was
// free rather than admit we don't know. The manager serves the figure
// from its own database, so it survives inference restarting. The strings
// come from describeCost in sessionFormat.ts.
import React from 'react';
import type { SessionCost } from '../api';
import { describeCost } from './sessionFormat';

const SessionCostBadge: React.FC<{ cost: SessionCost | null }> = ({ cost }) => {
  const d = describeCost(cost);
  if (!d) return null;
  return (
    <span className="text-muted" title={d.title}>
      {d.label}
    </span>
  );
};

export default SessionCostBadge;
